import { render, staticRenderFns } from "./BatchTable.vue?vue&type=template&id=7bb1564c&scoped=true&"
import script from "./BatchTable.vue?vue&type=script&lang=js&"
export * from "./BatchTable.vue?vue&type=script&lang=js&"
import style0 from "./BatchTable.vue?vue&type=style&index=0&id=7bb1564c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb1564c",
  null
  
)

export default component.exports